<template>
  <div class="testRegistration">
    <el-row :gutter="10">
      <el-col
        :xs="24"
        :sm="12"
        :md="12"
        :lg="8"
        :xl="8"
        v-for="(item,index) in data"
        :key="index"
        style="margin-top:10px;"
      >
        <el-card shadow="always" style="height: 245px;">
          <div slot="header" class="common_display">
            <p class="card_title common_display">
              <span
                style="width: 93%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;text-align: left"
              >{{(item.test_class_title)}}</span>
              <span style="color:#fff">&rarr;</span>
            </p>
            <p class="signUp" @click="signUp(item)">报 名</p>
          </div>
          <div class="card_content">
            <ul>
              <li
                class="card_content_li"
                style="width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: left;"
              >
                <span
                  class="icon common_backgroundImg"
                  :style="'background-image:url(' + iconList[0]  + ')'"
                ></span>
                测试地址：{{item.provinceName == item.cityName ?item.provinceName:item.provinceName+item.cityName}}{{item.districtName}}{{item.detailed_address}}
              </li>
              <li class="card_content_li">
                <span
                  class="icon common_backgroundImg"
                  :style="'background-image:url(' + iconList[1]  + ')'"
                ></span>
                报名时间：{{item.registration_start_time|dateformat('YYYY-MM-DD')}}至 {{item.registration_end_time|dateformat('YYYY-MM-DD')}}
              </li>
              <li class="card_content_li">
                <span
                  class="icon common_backgroundImg"
                  :style="'background-image:url(' + iconList[1]  + ')'"
                ></span>
                测试时间：{{item.test_start_time|dateformat('YYYY-MM-DD')}} 至 {{item.test_end_time|dateformat('YYYY-MM-DD')}}
              </li>
            </ul>
            <p class="line"></p>
            <div class="card_bottom">
              <span class="card_bottom_left" v-for="(item2,index) in item.grade" :key="index">
                {{item2.grade}}
                <label>\</label>
              </span>
              <!-- <span>
                <el-button
                  size="mini"
                  style="color:#f56c6c;border: 0.5px solid #f56c6c;border-radius: 4px;float:right"
                >详 情</el-button>
              </span>-->
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog title="等级选择" :visible.sync="chooseGradeVisible" :width="screenWidth>768?'40%':'90%'" center>
      <div style="margin-top: 20px;text-align:center">
        <el-radio-group v-model="bmInfo.key" v-for="(item,index) in gradeList" :key="index">
          <el-radio :label="item.key" border text-color style="margin-right:10px;">{{item.value}}</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="chooseGradeVisible = false">取 消</el-button>
        <el-button type="primary" @click="chooseGradeSure">确 定</el-button>
      </span>
    </el-dialog>
    <role-permissions
      :dialogVisible="dialogVisible"
      @changeDialogVisible="changeDialogVisible"
      roleName="运动员"
    />
  </div>
</template>

<script>
import { GetExaminerClassList } from "@/api/admin/common.js";
import { GetTestGradeList } from "@/api/admin/athletes.js";
import { mapGetters } from "vuex";
import rolePermissions from "@/views/admin/components/rolePermissions.vue";
export default {
  name: "",
  components: {
    rolePermissions
  },
  data() {
    return {
      data: [],
      iconList: ["/image/new/icon_place.png", "/image/new/icon_time.png"],
      paging: {
        limit: 6,
        page: 1
      },
      dialogVisible: false,
      chooseGradeVisible: false,
      gradeList: [],
      bmInfo: {}
    };
  },
  computed: {
    ...mapGetters(["userRole", "levels",'screenWidth'])
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      // 测试班列表
      GetExaminerClassList(Object.assign(this.paging)).then(data => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
        }
      });
    },
    signUp(item) {
      this.bmInfo = item;
      if (this.userRole == 1) {
        GetTestGradeList({ id: item.id }).then(data => {
          
          const list = data.data.result;
          this.gradeList = list.items;
          if (this.gradeList.length == 1) {
            this.$router.push({
              path: "/test/signUp",
              query: { id: item.id, key: this.gradeList[0].key }
            });
          } else if (this.gradeList.length == 0) {
            this.$message({
              message: "您未取得测试等级资格",
              type: "warning"
            });
          } else {
            this.chooseGradeVisible = true;
          }
        });
      } else {
        this.dialogVisible = true;
      }
    },
    changeDialogVisible(val) {
      this.dialogVisible = val;
    },
    chooseGradeSure() {
      if (this.bmInfo.key) {
        this.gradeList.forEach(i => {
          if (i.key == this.bmInfo.key) {
            Object.assign(this.bmInfo, i);
          }
        });
        this.$router.push({
          path: "/test/signUp",
          query: { id: this.bmInfo.id, key: this.bmInfo.key }
        });
        this.chooseGradeVisible = false;
      } else {
        this.$message({
          message: "请选择测试等级",
          type: "warning"
        });
      }
    }
  }
};
</script>

<style lang="less">
.testRegistration {
  margin-top: 10px;
  .el-card__body {
    padding: 5px;
  }
  .el-card__header {
    padding: 0px;
    color: #ffffff;
    text-align: center;
    .card_title {
      width: 80%;
      //background: linear-gradient(90deg, #ca6161 0%, #ffffff 130%);
      background: #ba442a;
      border-right: 1px solid #fff;
      box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
      padding: 8px 15px;
      box-sizing: border-box;
      span {
        display: block;
      }
      span + span {
        cursor: pointer;
      }
    }
    .signUp {
      width: 20%;
      background: #ba442a;
      padding: 8px 15px;
      cursor: pointer;
    }
  }
  .card_content {
    padding: 5px 10px;
    .icon {
      display: inline-block;
      width: 20px;
      height: 20px;
      position: relative;
      top: 4px;
    }
    .card_content_li,
    .card_bottom {
      margin: 10px 0px;
    }
    .line {
      border-bottom: 1px solid #c4c4c4;
    }
    .card_bottom_left {
      line-height: 32px;
      font-size: 13px;
    }
    .card_bottom_left:last-child label {
      display: none;
    }
    .el-button:focus,
    .el-button:hover {
      background: #fddfe5;
      border-color: #fddfe5;
      color: #fff;
    }
  }
}
</style>
